if (!customElements.get('product-media-slider')) {
  customElements.define(
    'product-media-slider',
    class ProductMediaSlider extends HTMLElement {
      constructor() {
        super();
        this.slides = this.querySelectorAll('.product-media-slider__slide');
        this.prevButton = this.querySelector('.product-media-slider__button--prev');
        this.nextButton = this.querySelector('.product-media-slider__button--next');
        this.currentIndex = 0;
        this.mediaCount = parseInt(this.dataset.mediaCount) || this.slides.length;

        if (this.slides.length <= 1) {
          if (this.prevButton) this.prevButton.style.display = 'none';
          if (this.nextButton) this.nextButton.style.display = 'none';
          return;
        }

        this.init();
      }

      init() {
        // Set initial active slide
        this.updateActiveSlide(0);

        // Add event listeners
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.goToPrevious());
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.goToNext());
        }

        // Keyboard navigation
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goToNext();
          }
        });

        // Touch/swipe support for mobile
        this.addTouchSupport();
      }

      goToPrevious() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          this.currentIndex = this.slides.length - 1;
        }
        this.updateActiveSlide(this.currentIndex);
      }

      goToNext() {
        if (this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0;
        }
        this.updateActiveSlide(this.currentIndex);
      }

      goToSlide(index) {
        if (index >= 0 && index < this.slides.length) {
          this.currentIndex = index;
          this.updateActiveSlide(this.currentIndex);
        }
      }

      updateActiveSlide(index) {
        // Remove active class from all slides
        this.slides.forEach((slide) => {
          slide.classList.remove('is-active');
        });

        // Add active class to current slide
        if (this.slides[index]) {
          this.slides[index].classList.add('is-active');
        }

        // Update button states
        this.updateButtonStates();

        // Play active media if it's a video
        this.playActiveMedia(this.slides[index]);
      }

      updateButtonStates() {
        if (this.prevButton) {
          this.prevButton.disabled = this.slides.length <= 1;
        }
        if (this.nextButton) {
          this.nextButton.disabled = this.slides.length <= 1;
        }
      }

      playActiveMedia(activeSlide) {
        if (!activeSlide) return;
        
        // Pause all media
        window.pauseAllMedia?.();
        
        // Load deferred media if present
        const deferredMedia = activeSlide.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent?.(false);
        }
      }

      addTouchSupport() {
        let touchStartX = 0;
        let touchEndX = 0;
        const minSwipeDistance = 50;

        this.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        }, { passive: true });

        this.handleSwipe = () => {
          const swipeDistance = touchStartX - touchEndX;
          
          if (Math.abs(swipeDistance) > minSwipeDistance) {
            if (swipeDistance > 0) {
              // Swipe left - go to next
              this.goToNext();
            } else {
              // Swipe right - go to previous
              this.goToPrevious();
            }
          }
        };
      }
    }
  );
}

